export default {
  footerTagline: 'Willkommen im Hotel Alpenhof Gauting.',
  footerAddress: 'Unterbrunner Straße 9\n82131 Gauting',
  footerPhone: '+49 89 8564 2910',
  footerCopyright: '© Hotel Alpenhof Gauting. Alle Rechte vorbehalten.',
  footerHomeLink: 'Zur Startseite',
  footerCareerLink: 'Arbeiten im Alpenhof',
  footerSectionContact: 'Kontakt',
  footerSectionReception: 'Rezeption',
  footerReceptionWeekday: 'Mo – Fr · 7 – 12 & 15 – 22 Uhr',
  footerReceptionWeekend: 'Sa, So & Feiertage · 8 – 12 & 15 – 22 Uhr',
  footerCtaButton: 'Zimmer anfragen',
  footerLegalImpressum: 'Impressum',
  footerLegalDatenschutz: 'Datenschutz',
  footerLegalAgb: 'AGB',

  // Sticky booking banner
  stickyTitle: 'Ihr Aufenthalt im Alpenhof',
  stickyTitleMobile: 'Verfügbarkeit prüfen',
  stickySubtitle: 'Verfügbarkeit prüfen & Bestpreis sichern',
  stickyButton: 'Jetzt buchen',
};
